/* eslint-disable react/no-danger */
import { useEffect, useRef } from "react";
import { transformToHtml, wireTopAirlineCarousel } from "../../utils/CommonUtils";
import parse from "html-react-parser";

export default function FlightRoutePWA(props) {
  const containerRef = useRef(null);

  const {
    language,
    contentBottom,
    contentTop,
    contentMiddle,
    top_overlay,
    leftBlock,
    rightBlock,
    bottomBlock,
    initial_js: initialJS = "",
    main_div: mainDiv,
    appConfig,
    ccde,
    isGoibibo = false,
  } = props?.data;
  let jsPath;
  let cssPath;
  if (appConfig?.liveMode) {
    jsPath = `https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/js`;
    cssPath = `https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/css`;
  } else {
    jsPath = "http://localhost:3000/_next/static/js";
    cssPath = "http://localhost:3000/_next/static/css";
  }
  useEffect(() => {
    wireTopAirlineCarousel(containerRef.current);
  }, [contentTop, contentMiddle, contentBottom, bottomBlock]);

  const intentOfferOverlayCSSPath = `${cssPath}/intentOfferOverlay.min.css`;
  const intentOfferOverlayJSPath = `${jsPath}/intentOffer.min.js`;
  const googleTagId = isGoibibo ? "GTM-5VDCXLQ" : "GTM-NWV3K7C";
  const googletTagString = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','${googleTagId}');
`;
  return (
    <>
      {initialJS && initialJS !== "" ? parse(initialJS) : null}
      <div dangerouslySetInnerHTML={{ __html: mainDiv }} />
      <div ref={containerRef} className="fli-intl-container prepend_top20 clearfix">
        <div className="fli-intl-lhs pull-left">
          <div className="seoOnlyBlock col-lg-9 col-md-12 col-sm-12 col-xs-12">
            {transformToHtml(contentTop)}
            {transformToHtml(contentMiddle)}
            {transformToHtml(contentBottom)}
            {transformToHtml(bottomBlock)}
          </div>
          <div className="seoOnlyBlock col-lg-3 col-md-12 col-sm-12 col-xs-12">
            {transformToHtml(leftBlock)}
            {transformToHtml(rightBlock)}
          </div>
        </div>
      </div>
      <div dangerouslySetInnerHTML={{ __html: top_overlay }} />
      <div className="overlay_hamburger" />
      <a id="back-top" className="back-to-top">
        &#160;
      </a>
      <link href={`${intentOfferOverlayCSSPath}`} rel="stylesheet" />
      <script defer type="text/javascript" src={`${intentOfferOverlayJSPath}`} />
      {ccde && (ccde === "" || ccde === "in" || ccde === "IN") ? (
        <script dangerouslySetInnerHTML={{ __html: googletTagString }} />
      ) : null}
    </>
  );
}
